import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { InvoiceResponse } from "../../../../types/sale.type";
import { useCompact } from "../../../../utils/hooks/useCompact";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import InvoiceDetailsTabs from "./Tabs";
import DetailsDocument from "./Document";
import FooterComment from "./FooterComment";

interface InvoiceDetailsProps {
  invoice: InvoiceResponse;
  setTriggerFetch: Dispatch<SetStateAction<number>>;
}

export default function InvoiceDetails({
  invoice,
  setTriggerFetch,
}: InvoiceDetailsProps) {
  const compact = useCompact();
  const [statusTab, setStatusTab] = useState<string>("ข้อมูลเอกสาร");
  const [comment, setComment] = useState<string>("");
  const [commentLoading, setCommentLoading] = useState<boolean>(false);
  const [reqChangeLoading, setReqChangeLoading] = useState<boolean>(false);

  useEffect(() => {
    setComment(invoice.comment || "");
  }, [invoice.comment]);

  return (
    <>
      <InvoiceDetailsTabs statusTab={statusTab} setStatusTab={setStatusTab} />
      <Paper
        sx={{
          padding: "16px 24px",
          borderRadius: "0 12px 12px 12px",
          marginBottom: statusTab === "ข้อมูลเอกสาร" ? "0" : "36px",
          ...(compact && { padding: "12px 16px" }),
        }}
      >
        {invoice && statusTab === "ข้อมูลเอกสาร" && (
          <DetailsDocument
            invoice={invoice}
            setTriggerFetch={setTriggerFetch}
          />
        )}
        {statusTab === "ประวัติการทำรายการ" && <>ประวัติการทำรายการ</>}
      </Paper>
      {invoice && statusTab === "ข้อมูลเอกสาร" && (
        <Paper
          sx={{
            padding: "16px 24px 24px",
            marginTop: "24px",
            marginBottom: "48px",
            ...(compact && {
              padding: "12px 16px 16px",
              marginTop: "16px",
              marginBottom: "80px",
            }),
          }}
        >
          <Typography fontWeight={600} variant="body1" mb={compact ? 1 : 2}>
            หมายเหตุ
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={compact ? 2 : 4}
            value={comment}
            disabled={commentLoading}
            onChange={(e) => setComment(e.target.value)}
          />
        </Paper>
      )}
      <FooterComment
        comment={comment}
        uuid={invoice.uuid}
        status={invoice.status}
        replacedBy={invoice.replaced_by}
        commentLoading={commentLoading}
        setCommentLoading={setCommentLoading}
        reqChangeLoading={reqChangeLoading}
        setReqChangeLoading={setReqChangeLoading}
        setTriggerFetch={setTriggerFetch}
      />
    </>
  );
}
